import React from 'react';
import { dateTimeSaparator } from '../../../../helper/formatDate';

export const MeetingUserCell = ({ row }) => {
    const user = row.callerUser;
    const userName = user
        ? `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.username || `Staff #${user.id}`
        : 'System / Staff';
    const dt = dateTimeSaparator(row.created_at);

    return (
        <div className="py-1">
            {/* Followed By User Info */}
            <div className="d-flex align-items-center gap-1.5">
                <span className="avatar-xs rounded-circle bg-soft-info text-info fw-bold d-inline-flex align-items-center justify-content-center fs-11" style={{ width: '24px', height: '24px' }}>
                    {userName.charAt(0).toUpperCase()}
                </span>
                <span className="fw-semibold text-dark fs-12 text-truncate" style={{ maxWidth: '140px' }} title={`Followed by: ${userName}`}>
                    {userName}
                </span>
            </div>

            {/* Follow-up Logged Timestamp */}
            <div className="text-muted fs-11 d-flex align-items-center gap-1 mt-1">
                <i className="ri-time-line text-muted" />
                <span>{dt.date || 'N/A'}</span>
                {dt.time && <span className="text-muted">({dt.time})</span>}
            </div>
        </div>
    );
};

export default MeetingUserCell;
